import httpRequest from "@/infra/httpRequest";

export default class CreditCardsBins {
    public async getBinsAvailable(pageId: string): Promise<number[]> {
        try {
            const {
                data: { credit_cards_bins_available }
            } = await httpRequest.get(`/pages/${pageId}/credit_cards/bins/available`);

            return credit_cards_bins_available.map((bin: { bin: number, name: string }) => bin.bin)
        } catch (err) {
            throw Error;
        }
    }
}